export default __webpack_public_path__ + "static/media/yuoo-913x1335.87471d69.jpg";